import { useState, useEffect, useRef } from "react";
import DeleteModal from "./DeleteModal";
import firebase from "../util/firebase";
import HeadshotImage from "../assets/images/headshot.png";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CoBrandingOptions({
  enableCobranding,
  setEnableCobranding,
  currentUser,
  coBrandFirstName,
  coBrandLastName,
  coBrandTitle,
  coBrandPhone,
  coBrandFaxPhone,
  coBrandCompanyName,
  coBrandEmail,
  coBrandWebsite,
  inputFile,
  validateCoBrandingFields,
  firstNameError,
  lastNameError,
  titleError,
  cobrandHeadshot,
  setCobrandHeadshot,
}) {
  const [cobranders, setCobranders] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [selectedCobrander, setSelectedCobrander] = useState(null);
  const [notification, setNotification] = useState("");
  const [notificationType, setNotificationType] = useState("");

const onButtonClick = () => {
  inputFile.current.click();
};

  const handleSelectCobrander = (e) => {
    if (e.target.value === "new") {
      setSelectedCobrander(null);
      coBrandFirstName.current.value = "";
      coBrandLastName.current.value = "";
      coBrandTitle.current.value = "";
      coBrandPhone.current.value = "";
      coBrandFaxPhone.current.value = "";
      coBrandCompanyName.current.value = "";
      coBrandEmail.current.value = "";
      coBrandWebsite.current.value = "";
      setCobrandHeadshot("");
    } else {
      const selected = cobranders.find(
        (cobrander) => cobrander.id === e.target.value
      );
      setSelectedCobrander(selected);
      coBrandFirstName.current.value = selected.firstName;
      coBrandLastName.current.value = selected.lastName;
      coBrandTitle.current.value = selected.title;
      coBrandPhone.current.value = selected.phone;
      coBrandFaxPhone.current.value = selected.faxPhone;
      coBrandCompanyName.current.value = selected.companyName;
      coBrandEmail.current.value = selected.email;
      coBrandWebsite.current.value = selected.website;
      setCobrandHeadshot(selected.headshot);
    }
  };

  const uploadUserHeadshot = (e) => {
    const url = "https://api.cloudinary.com/v1_1/dqbckxsgm/image/upload";
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    formData.append("upload_preset", "rcoy0hs1");
    formData.append("api_key", "789145474162712");
    formData.append("folder", "Headshots");

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        setCobrandHeadshot(data.secure_url);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveCobranderInfo = () => {
    if (!validateCoBrandingFields()) {
      return; // Exit if the validation fails
    }

    const cobranderInfo = {
      firstName: coBrandFirstName.current.value,
      lastName: coBrandLastName.current.value,
      title: coBrandTitle.current.value,
      phone: coBrandPhone.current.value,
      faxPhone: coBrandFaxPhone.current.value,
      companyName: coBrandCompanyName.current.value,
      email: coBrandEmail.current.value,
      website: coBrandWebsite.current.value,
      headshot: cobrandHeadshot || "",
      userId: currentUser.uid,
    };

    firebase
      .firestore()
      .collection("cobranders")
      .add(cobranderInfo)
      .then((docRef) => {
        const newCobrander = { id: docRef.id, ...cobranderInfo };
        setSelectedCobrander(newCobrander);
        setCobranders([...cobranders, newCobrander]);

        setNotification("Cobrander information saved successfully!");
        setNotificationType("success");
        setTimeout(() => {
          setNotification("");
          setNotificationType("");
        }, 5000);
      })
      .catch((error) => {
        console.error("Error saving cobrander information: ", error);
        setNotification("Error saving cobrander information!");
        setNotificationType("error");
        setTimeout(() => {
          setNotification("");
          setNotificationType("");
        }, 5000);
      });

    // update the cobranders list
    setCobranders([...cobranders, cobranderInfo]);
  };

  const updateCobranderInfo = () => {
    if (!validateCoBrandingFields()) {
      return; // Exit if the validation fails
    }

    const cobranderInfo = {
      firstName: coBrandFirstName.current.value,
      lastName: coBrandLastName.current.value,
      title: coBrandTitle.current.value,
      phone: coBrandPhone.current.value,
      faxPhone: coBrandFaxPhone.current.value,
      companyName: coBrandCompanyName.current.value,
      email: coBrandEmail.current.value,
      website: coBrandWebsite.current.value,
      headshot: cobrandHeadshot,
      userId: currentUser.uid,
    };

    firebase
      .firestore()
      .collection("cobranders")
      .doc(selectedCobrander.id)
      .set(cobranderInfo)
      .then(() => {
        setNotification("Cobrander information updated successfully!");
        setNotificationType("success");
        setTimeout(() => {
          setNotification("");
          setNotificationType("");
        }, 5000);
      })
      .catch((error) => {
        console.error("Error updating cobrander information: ", error);
        setNotification("Error updating cobrander information!");
        setNotificationType("error");
        setTimeout(() => {
          setNotification("");
          setNotificationType("");
        }, 5000);
      });

    // update the cobranders list
    setCobranders(
      cobranders.map((cobrander) =>
        cobrander.id === selectedCobrander.id
          ? { ...cobrander, ...cobranderInfo }
          : cobrander
      )
    );
  };

  const deleteCobranderInfo = () => {
    firebase
      .firestore()
      .collection("cobranders")
      .doc(selectedCobrander.id)
      .delete()
      .then(() => {
        setNotification("Cobrander deleted successfully!");
        setNotificationType("success");
        setTimeout(() => {
          setNotification("");
          setNotificationType("");
        }, 5000);
        setSelectedCobrander(null);
        coBrandFirstName.current.value = "";
        coBrandLastName.current.value = "";
        coBrandTitle.current.value = "";
        coBrandPhone.current.value = "";
        coBrandFaxPhone.current.value = "";
        coBrandCompanyName.current.value = "";
        coBrandEmail.current.value = "";
        coBrandWebsite.current.value = "";
        setCobrandHeadshot("");

        setCobranders(
          cobranders.filter(
            (cobrander) => cobrander.id !== selectedCobrander.id
          )
        );
      })
      .catch((error) => {
        console.error("Error deleting cobrander information: ", error);
        setNotification("Error deleting cobrander information!");
        setNotificationType("error");
        setTimeout(() => {
          setNotification("");
          setNotificationType("");
        }, 5000);
      });
  };

  useEffect(() => {
    if (currentUser && currentUser.uid) {
      console.log("Current User ID: ", currentUser.uid);

      firebase
        .firestore()
        .collection("cobranders")
        .where("userId", "==", currentUser.uid)
        .get()
        .then((querySnapshot) => {
          const cobranderList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setCobranders(cobranderList);
        })
        .catch((error) => {
          console.error("Error fetching cobranders: ", error);
        });
    }
  }, [currentUser]);

  return (
    <div className="flex flex-col md:w-2/5 my-2 space-y-3 min-h-[400px]">
      <h2 className="text-blue-primary text-2xl underline mr-4">
        Co-Branding Options
      </h2>
      <div className="flex ml-28 space-x-4 items-center">
        <div className="h-5 mb-1">
          <input
            id="coBranding"
            aria-describedby="comments-description"
            name="coBranding"
            type="checkbox"
            onChange={() => setEnableCobranding(!enableCobranding)}
            className="focus:ring-blue-complimentary h-5 w-5 text-blue-complimentary border-gray-300 rounded"
          />
        </div>
        <label
          htmlFor="coBranding"
          className="text-blue-primary text-xl font-semibold cursor-pointer"
        >
          Enable Co-Branding
        </label>
      </div>

      {enableCobranding && (
        <div className="w-3/5 ml-28">
          {enableCobranding && (
            <div>
              <label
                htmlFor="selectCobrander"
                className="block text-sm font-medium text-gray-500 text-left pl-1"
              >
                Select a Cobrander (optional)
              </label>
              <select
                id="selectCobrander"
                className="shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm border border-gray-300 rounded-md pl-2"
                onChange={handleSelectCobrander}
                value={selectedCobrander ? selectedCobrander.id : "new"} // Updated value attribute
              >
                <option value="new">Create a New Cobrander</option>{" "}
                {cobranders.map((cobrander) => (
                  <option key={cobrander.id} value={cobrander.id}>
                    {cobrander.firstName} {cobrander.lastName}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}

      <div
        id=""
        className={classNames(
          enableCobranding ? "" : "h-[160px] truncate",
          " fade-in"
        )}
      >
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandFirstname"
            className="block text-sm font-medium text-gray-500 text-left pl-1"
          >
            First Name (required)
          </label>
          <div className="mt-0">
            <input
              ref={coBrandFirstName}
              disabled={!enableCobranding}
              type="text"
              name="cobrandFirstname"
              id="cobrandFirstname"
              placeholder="John"
              className={classNames(
                firstNameError
                  ? "border-2 border-red-600"
                  : "border border-gray-300",
                "shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              )}
            />
          </div>
          {firstNameError && (
            <p className="text-sm text-red-600 text-left pl-2 pb-1">
              Please fill out the first name.
            </p>
          )}
        </div>
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandingLastName"
            className="block text-sm font-medium text-gray-500 text-left pl-1"
          >
            Last Name (required)
          </label>
          <div className="mt-0">
            <input
              ref={coBrandLastName}
              disabled={!enableCobranding}
              type="text"
              name="cobrandingLastName"
              id="cobrandingLastName"
              placeholder="Smith"
              className={classNames(
                lastNameError
                  ? "border-2 border-red-600"
                  : "border border-gray-300",
                "shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              )}
            />
          </div>
          {lastNameError && (
            <p className="text-sm text-red-600 text-left pl-2 pb-1">
              Please fill out the last name.
            </p>
          )}
        </div>
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandingTitle"
            className="block text-sm font-medium text-gray-500 text-left pl-1"
          >
            Title (required)
          </label>
          <div className="mt-0">
            <input
              ref={coBrandTitle}
              disabled={!enableCobranding}
              type="text"
              name="cobrandingTitle"
              id="cobrandingTitle"
              placeholder="Real Estate Agent"
              className={classNames(
                titleError
                  ? "border-2 border-red-600"
                  : "border border-gray-300",
                "shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              )}
            />
          </div>
          {titleError && (
            <p className="text-sm text-red-600 text-left pl-2 pb-1">
              Please fill out the title.
            </p>
          )}
        </div>
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandingPhone"
            className="block text-sm font-medium text-gray-500 text-left pl-1 "
          >
            Phone Number
          </label>
          <div className="mt-0">
            <input
              ref={coBrandPhone}
              disabled={!enableCobranding}
              type="tel"
              pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
              name="cobrandingPhone"
              id="cobrandingPhone"
              className="shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm border border-grey-300 rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              placeholder="(555) 555-5555"
            />
          </div>
        </div>
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandingFaxPhone"
            className="block text-sm font-medium text-gray-500 text-left pl-1 "
          >
            Mobile Number
          </label>
          <div className="mt-0">
            <input
              ref={coBrandFaxPhone}
              disabled={!enableCobranding}
              type="tel"
              pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
              name="cobrandingFaxPhone"
              id="cobrandingFaxPhone"
              className="shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm border border-grey-300 rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              placeholder="(555) 555-5555"
            />
          </div>
        </div>
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandCompanyName"
            className="block text-sm font-medium text-gray-500 text-left pl-1 "
          >
            Company Name
          </label>
          <div className="mt-0">
            <input
              ref={coBrandCompanyName}
              disabled={!enableCobranding}
              type="text"
              name="cobrandCompanyName"
              id="cobrandCompanyName"
              className="shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm border border-grey-300 rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              placeholder="OneTrust Home Loans"
            />
          </div>
        </div>
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandEmail"
            className="block text-sm font-medium text-gray-500 text-left pl-1 "
          >
            Email Address
          </label>
          <div className="mt-0">
            <input
              ref={coBrandEmail}
              disabled={!enableCobranding}
              type="text"
              name="cobrandEmail"
              id="cobrandEmail"
              className="shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm border border-grey-300 rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              placeholder="jdoe@gmail.com"
            />
          </div>
        </div>
        <div className="w-3/5 ml-28">
          <label
            htmlFor="cobrandWebsite"
            className="block text-sm font-medium text-gray-500 text-left pl-1 "
          >
            Website URL
          </label>
          <div className="mt-0">
            <input
              ref={coBrandWebsite}
              disabled={!enableCobranding}
              type="text"
              name="cobrandWebsite"
              id="cobrandWebsite"
              className="shadow-sm focus:ring-blue-primary focus:border-blue-primary block w-full sm:text-sm border border-grey-300 rounded-md pl-2 h-6 border-solid border-1 border-gray-300 disabled:opacity-50 disabled:bg-gray-200"
              placeholder="onetrusthomeloans.com"
            />
          </div>
        </div>
        <div className="w-3/5 ml-28 pt-4">
          <span className=" block text-sm font-semibold text-gray-500 text-center pb-1 underline">
            For best result upload square images only
          </span>
          <input
            type="file"
            id="file"
            disabled={!enableCobranding}
            ref={inputFile}
            style={{ display: "none" }}
            onChange={(e) => {
              uploadUserHeadshot(e);
            }}
          />{" "}
          <button
            disabled={!enableCobranding}
            onClick={onButtonClick}
            type="button"
            className="hover:-translate-y-1 disabled:opacity-50 relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary"
          >
            <div className="flex justify-center h-12">
              <img src={HeadshotImage} alt="headshot" />
            </div>
            <span className="mt-2 block text-sm font-medium text-gray-500">
              Add a co-branding headshot
            </span>
          </button>
          <span className=" block text-sm font-normal text-gray-400 text-left">
            Only PNG and JPG files are allowed.
          </span>
          {cobrandHeadshot && (
            <span className="mt-2 block text-sm font-medium text-blue-primary pb-2 text-left">
              Image uploaded successfully
            </span>
          )}
        </div>
        <div className="w-36 ml-28">
          {cobrandHeadshot && (
            <div className="relative">
              <div
                onClick={() => {
                  setCobrandHeadshot(null);
                  inputFile.current.value = "";
                }}
                className="absolute text-red-error bg-white rounded-full h-6 w-6 top-2 right-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <img src={cobrandHeadshot} alt="headshot" />
            </div>
          )}
        </div>
        <div className="w-3/5 ml-28">
          {notification && (
            <span
              className={`mt-2 block text-sm font-medium text-${
                notificationType === "success" ? "blue" : "red"
              }-primary pb-2 text-left`}
            >
              {notification}
            </span>
          )}
          {enableCobranding && (
            <div className="flex justify-center space-x-4">
              <button
                onClick={
                  selectedCobrander ? updateCobranderInfo : saveCobranderInfo
                }
                type="button"
                className={classNames(
                  "my-6 px-3 py-2 w-48 border border-gray-300 rounded-md shadow-sm text-lg font-medium text-white bg-blue-primary hover:bg-blue-complimentary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-complimentary"
                )}
              >
                {selectedCobrander ? "Update Cobrander" : "Save Cobrander"}
              </button>
              {selectedCobrander && (
                <button
                  onClick={() => setDeleteStatus(true)}
                  type="button"
                  className="my-6 px-3 py-2 w-40 border border-gray-300 rounded-md shadow-sm text-lg font-medium text-white bg-rose-900 hover:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Delete
                </button>
              )}
              {deleteStatus && (
                <DeleteModal
                  setDeleteStatus={setDeleteStatus}
                  handleDelete={() => {
                    deleteCobranderInfo();
                    setDeleteStatus(false);
                  }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
